<script lang="ts">
    import { apiClient } from "./apiClient";
    import { error, success } from "./stores";

    let username = "";
    let password = "";
    let isLoading = false;

    async function handleLogin() {
        if (!username || !password) {
            error.set("Bitte Benutzername und Passwort eingeben");
            return;
        }

        isLoading = true;
        try {
            await apiClient.login(username, password);
            success.set("Erfolgreich angemeldet!");
            // Trigger a page refresh or navigation to the main app
            window.location.reload();
        } catch (err) {
            error.set(
                err instanceof Error ? err.message : "Login fehlgeschlagen",
            );
        } finally {
            isLoading = false;
        }
    }

    function handleSubmit(event: Event) {
        event.preventDefault();
        handleLogin();
    }
</script>

<main class="login-container">
    <div class="login-card">
        <h1>🍹 Drinks Admin</h1>
        <h2>Anmeldung</h2>

        <form on:submit={handleSubmit}>
            <div class="form-group">
                <label for="username">Benutzername:</label>
                <input
                    id="username"
                    type="text"
                    bind:value={username}
                    disabled={isLoading}
                    required
                />
            </div>

            <div class="form-group">
                <label for="password">Passwort:</label>
                <input
                    id="password"
                    type="password"
                    bind:value={password}
                    disabled={isLoading}
                    required
                />
            </div>

            <button type="submit" disabled={isLoading}>
                {#if isLoading}
                    Anmelden...
                {:else}
                    Anmelden
                {/if}
            </button>
        </form>
    </div>
</main>

<style>
    .login-container {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        background-color: #f5f5f5;
    }

    .login-card {
        background: white;
        padding: 2rem;
        border-radius: 10px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        width: 100%;
        max-width: 400px;
    }

    h1 {
        text-align: center;
        color: #2c3e50;
        margin-bottom: 0.5rem;
        font-size: 2.5rem;
    }

    h2 {
        text-align: center;
        color: #34495e;
        margin-bottom: 2rem;
        font-size: 1.5rem;
    }

    form {
        width: 100%;
    }

    .form-group {
        margin-bottom: 1.5rem;
        width: 100%;
    }

    label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: bold;
        color: #2c3e50;
        width: 100%;
    }

    input {
        width: 100%;
        box-sizing: border-box;
        padding: 0.75rem;
        border: 2px solid #bdc3c7;
        border-radius: 5px;
        font-size: 1rem;
        transition: border-color 0.3s;
        display: block;
    }

    input:focus {
        outline: none;
        border-color: #3498db;
    }

    input:disabled {
        background-color: #ecf0f1;
        cursor: not-allowed;
    }

    button {
        width: 100%;
        padding: 0.75rem;
        background-color: #3498db;
        color: white;
        border: none;
        border-radius: 5px;
        font-size: 1rem;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    button:hover:not(:disabled) {
        background-color: #2980b9;
    }

    button:disabled {
        background-color: #bdc3c7;
        cursor: not-allowed;
    }
</style>
